(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["td-service-icon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-service-motion')) {
 const panels = new WeakMap();
 class PanelEntrance {
  constructor(panel) { this.panel=panel; this.refs=new Set(); this.animations=new Map(); this.controller=new AbortController(); this.frame=requestAnimationFrame(()=>this.init()); }
  init() {
   const columns=[...this.panel.querySelectorAll('td-service-motion')].map(icon=>icon.closest('.group-block'));
   this.targets=[this.panel,...new Set(columns)];
   this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
   const reveal=()=>this.reveal();
   this.panel.addEventListener('focusin',reveal,{signal:this.controller.signal});
   this.panel.addEventListener('shopify:block:select',reveal,{signal:this.controller.signal});
   this.panel.addEventListener('shopify:section:select',reveal,{signal:this.controller.signal});
   this.reduced.addEventListener('change',event=>{if(event.matches)this.reveal();},{signal:this.controller.signal});
   if(this.reduced.matches || !('IntersectionObserver' in window) || !this.panel.animate) {this.reveal();return;}
   const mobile=matchMedia('(max-width: 767px)').matches;
   this.observer=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
     if(!entry.isIntersecting)return;
     const animation=this.animations.get(entry.target);
     if(!animation)return;
     this.observer.unobserve(entry.target);
     entry.target.dataset.tdServiceMotion='playing'; animation.play();
    });
   },{threshold:.12,rootMargin:'0px 0px -24px 0px'});
   this.targets.forEach((target,index)=>{
    const panel=index===0;
    const animation=target.animate(
     [{opacity:0,transform:'translateY('+ (panel?20:28)+'px)'},{opacity:1,transform:'translateY(0)'}],
     {duration:panel?650:560,delay:panel||mobile?0:(index-1)*90,fill:'both',easing:'cubic-bezier(.22,1,.36,1)'}
    );
    animation.pause(); target.dataset.tdServiceMotion='ready'; this.animations.set(target,animation);
    animation.finished.then(()=>{
     if(this.animations.get(target)!==animation)return;
     target.dataset.tdServiceMotion='done'; animation.cancel();this.animations.delete(target);
    }).catch(()=>{});
    this.observer.observe(target);
   });
  }
  reveal() {
   this.observer?.disconnect();
   this.animations.forEach(animation=>animation.cancel());this.animations.clear();
   this.targets?.forEach(target=>{target.dataset.tdServiceMotion='visible';});
  }
  destroy() {cancelAnimationFrame(this.frame);this.reveal();this.controller.abort();}
 }
 customElements.define('td-service-motion',class extends HTMLElement {
  connectedCallback() {
   if(window.tdPdpEntryEnabled)return;
   const column=this.closest('.group-block');
   const panel=column?.parentElement.closest('.group-block');
   if(!panel)return;
   let entrance=panels.get(panel);
   if(!entrance){entrance=new PanelEntrance(panel);panels.set(panel,entrance);}
   this.entrance=entrance; entrance.refs.add(this);
  }
  disconnectedCallback() {
   const entrance=this.entrance;if(!entrance)return;
   entrance.refs.delete(this);
   if(!entrance.refs.size){entrance.destroy();panels.delete(entrance.panel);}
   this.entrance=null;
  }
 });
}
  } catch(e) { console.error(e); }
})();

})();
